import { Theme, createStyles, makeStyles } from '@forgeglobal/design-framework';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      height: '100%',
      '& .MuiTypography-overline': {
        paddingBottom: theme.spacing(2),
      },
    },
    maturityDateContainer: {
      paddingRight: theme.spacing(0),
      [theme.breakpoints.down('md')]: {
        paddingRight: theme.spacing(30),
      },
      [theme.breakpoints.up('md')]: {
        paddingRight: theme.spacing(55),
      },
    },
    content: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
    },
    container: {
      display: 'flex',
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
      },
      [theme.breakpoints.up('sm')]: {
        flexDirection: 'row',
      },
    },
    maturityDateAmount: {
      fontSize: 16,
      color: '#4B5662',
      [theme.breakpoints.down('md')]: {
        paddingBottom: theme.spacing(2),
      },
      [theme.breakpoints.up('md')]: {
        paddingBottom: theme.spacing(0),
      },
    },
    interestRateAmount: {
      fontSize: 16,
      color: '#4B5662',
      paddingBottom: theme.spacing(0),
    },
    maturityDate: {
      paddingBottom: theme.spacing(0.25),
    },
    interestRate: {
      paddingBottom: theme.spacing(0.25),
    },
  })
);
